namespace e5.ScrollViewResize {
    export class ScrollViewResizeContain implements IScrollViewResize {
        public getTransform(view: ScrollView, widthBefore: number, heightBefore: number): ScrollViewTransform {
            var scale = ScrollViewScale.Contain.getScale(view);
            return {
                scale: scale,
                x: view.width * 0.5 - (view.contentWidth * 0.5) * scale,
                y: view.height * 0.5 - (view.contentHeight * 0.5) * scale
            };
        }
    }

    export const Contain = new ScrollViewResizeContain();
}